let scrollPosition = window.scrollY;
let accessSide = document.getElementsByClassName('side-accessibility')[0];

window.addEventListener('scroll', function(){

    document.querySelector('#pojo-a11y-toolbar').classList.remove('pojo-a11y-toolbar-open');

    scrollPosition = window.scrollY;

    if(scrollPosition >= 150){
        accessSide.classList.add('access-scrolled');
    } else {
        accessSide.classList.remove('access-scrolled');
    }

})

let accessButton = document.querySelector('#accessibility');
let accessButtonFooter = document.querySelector('.access-footer');

accessButton.addEventListener('click', function(){
    document.querySelector('#pojo-a11y-toolbar').classList.toggle('pojo-a11y-toolbar-open');
})

accessButtonFooter.addEventListener('click', function(){
    document.querySelector('#pojo-a11y-toolbar').classList.toggle('pojo-a11y-toolbar-open');
})
